import { ColumnLayoutContainer } from "@mittwald/flow-components/dist/components/ColumnLayoutContainer";
import { RejectionAnimation } from "@mittwald/flow-components/dist/components/RejectionAnimation";
import { TextField } from "@mittwald/flow-components/dist/components/TextField";
import type { AnimationController } from "@mittwald/flow-components/dist/hooks/useAnimationController";
import { isEmail } from "@mittwald/flow-lib/dist/validation";
import type { FC } from "react";
import React from "react";

export interface LoginFormFieldProps {
  rejectionAnimation: AnimationController;
}

export const LoginForm: FC<LoginFormFieldProps> = (props) => {
  const { rejectionAnimation } = props;

  return (
    <RejectionAnimation animationController={rejectionAnimation}>
      <ColumnLayoutContainer>
        <TextField
          autoComplete="email"
          label="email"
          name="email"
          rules={{
            required: true,
            validate: {
              oldAccount: (value: string) =>
                !/^[r][0-9]{3}|[p][0-9]{4}|[0-9]{7}$/.test(
                  value.toLowerCase(),
                ) || isEmail(value),
              email: (value: string) => isEmail(value),
            },
          }}
        />
        <TextField
          autoComplete="password"
          label="password"
          name="password"
          rules={{
            required: true,
          }}
          type="password"
        />
      </ColumnLayoutContainer>
    </RejectionAnimation>
  );
};
